import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private http = inject(HttpClient);
    private authService = inject(AuthService);
    private baseUrl = environment.apiUrl;
    private headers = new HttpHeaders();
    private accessToken = this.authService.getAccessToken();

    constructor() {
        if (this.accessToken) {
            this.headers = new HttpHeaders().set('Authorization', `Bearer ${this.accessToken}`);
        }
    }

    getCurrentUser(): Observable<any> {
        return this.http.get(this.baseUrl + 'users/me', { headers: this.headers });
    }

    updatePassword(newPassword: string): Observable<any> {
        const url = `${this.baseUrl}users/update-password`;
        return this.http.put(url, newPassword, { headers: this.headers });
    }
}
